import { render } from "./BellIcon.vue?vue&type=template&id=03baef9c"
import script from "./BellIcon.vue?vue&type=script&lang=js"
export * from "./BellIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__